import React, { useState, memo } from 'react';
import { Link } from 'react-router-dom';

const MenuItem = memo(({ to, onClick, children }) => (
  <li>
    <Link to={to} onClick={onClick}>
      {children}
    </Link>
  </li>
));

const ServicesSubmenu = memo(({ services, isVisible, onLinkClick }) => (
  <div className={`submenu ${isVisible ? 'visible' : ''}`}>
    {services.map(({ slug: { current }, title }) => (
      <Link
        key={current}
        to={`/${current}`}
        onClick={onLinkClick}
      >
        {title}
      </Link>
    ))}
  </div>
));

const navigationItems = [
  { to: '/about-us', label: 'about' },
  { to: '/project', label: 'projects' },
  { to: '/blogs', label: 'Blog' },
  { to: '/media', label: 'media' },
  { to: '/faq', label: 'Faq' },
  { to: '/career', label: 'careers' }
];

const MobileMenu = ({ isOpen, setIsOpen, services }) => {
  const [activeMenu, setActiveMenu] = useState(null);

  const handleMenuClick = (menu) => {
    setActiveMenu(prevMenu => prevMenu === menu ? null : menu);
  };

  const handleLinkClick = () => {
    setIsOpen(false);
  };

  return (
    <section className={`menubar-area ${isOpen ? 'open-menu' : 'close-menu'}`}>
      <button 
        className="menu-close-btn"
        onClick={() => setIsOpen(false)}
        aria-label="Close menu"
      >
        ✕
      </button>

      <ul className="menu-toggel-items">
        {navigationItems.map(({ to, label }) => (
          <MenuItem 
            key={to}
            to={to}
            onClick={handleLinkClick}
          >
            {label}
          </MenuItem>
        ))}

        <li>
          <div className="mobile-slidelink">
            <button
              onClick={() => handleMenuClick('Service')}
              className="flex items-center justify-between w-full"
            >
              Services
              <span>{activeMenu === 'Service' ? '−' : '+'}</span>
            </button>
          </div>

          <ServicesSubmenu
            services={services}
            isVisible={activeMenu === 'Service'}
            onLinkClick={handleLinkClick}
          />
        </li>
      </ul>

      <div className="mobilemenu-cta">
        <Link 
          to="/contact-us"
          className="default-btn"
          onClick={handleLinkClick}
        >
          Contact us
          <span></span>
        </Link>
      </div>
    </section>
  );
};

export default memo(MobileMenu);